<script setup lang="ts">
import { faTimes } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

const props = withDefaults(
    defineProps<{
        closeable?: boolean;
        onClose?: (cancel: () => void) => void;
        padded?: boolean;
        disabled?: boolean;
    }>(),
    {
        closeable: true,
        padded: true,
    },
);

const store = useAutomationStore();

function close() {
    setExpanded(undefined);
}

function setExpanded(v: number | undefined) {
    store.setActiveStepIndex(v);
}

function actualClose() {
    props.onClose ? props.onClose(close) : close();
}

function onError(error: Error) {
    console.error(error);
}
</script>

<template>
    <UCard :ui="{ rounded: 'rounded-none', body: { base: 'flex-1 relative' } }" class="h-full flex flex-col">
        <template #header>
            <!-- Content -->
            <div class="flex items-center justify-between">
                <h3 class="text-base font-medium font-display leading-6 text-gray-900 dark:text-white">
                    <slot name="title" :close="actualClose" />
                </h3>
                <UButton
                    v-if="closeable"
                    square
                    :disabled="disabled"
                    color="gray"
                    variant="ghost"
                    size="sm"
                    @click="actualClose"
                >
                    <FontAwesomeIcon :icon="faTimes" size="lg" />
                </UButton>
            </div>
            <p v-if="$slots.description" class="text-sm mt-3">
                <slot name="description" />
            </p>
        </template>
        <NuxtErrorBoundary @error="onError">
            <template #error="{ error }">
                <UAlert color="red" title="Error" :description="error" />
            </template>
            <div class="absolute left-0 top-0 w-full h-full overscroll-y-auto overflow-x-hidden" :class="{
                'p-4': padded,
            }">
                <slot :close="actualClose" />
            </div>
        </NuxtErrorBoundary>
        <template v-if="$slots.footer" #footer>
            <slot name="footer" :close="actualClose" />
        </template>
    </UCard>
</template>
